import _ from "lodash";
import { MaxNumberOfSupportFiles, MaxSupportFileSizeInMB } from "../models/constants/support.constants";
import { tableSidePanelShortcuts } from "./utils";
import { IGetSpecificResourceDefinitionActionLabels as IGetSpecificRawDataLabels, IWebAppLabels } from "./webAppLabels.interface";
import { ResourceType } from "../models/api";

export const Labels: IWebAppLabels = {
    violationRulesPage: {
        platforms: {
            powerPlatform: "Power platform",
            workato: "Workato",
        },
        selectIntegrationPlaceHolder: "Integrations",
        defaultRuleDescription: "Governs Environments t haven't been assigned manually & resources residing outside the Environments space",
        exemptionsListTitle: "Exemption list",
        statusChangedSuccessfullyMessage: "Status changed",
        overviewTitle: "Overview",
        overviewTiles: {
            ruleDetailsTile: {
                title: "Policy Details",
                category: "Category",
                attackLink: "ATT&CK",
            },
            scopeTile: {
                title: "Integration",
                platform: "Platform",
                name: "Name",
                id: "ID",
            },
        },
        statusTitle: "Status",
        ruleIdTitle: "Policy ID",
        exemptionsList: {
            resourceNameCol: "Resource name",
            resourceLinkCol: "Resource link",
            dateAddedToExemptionCol: "Date added to exemption",
            exemptionAddedByCol: "Added by",
        },
        ruleActions: {
            disableButton: "Disable",
            enableButton: "Enable",
            editButton: "Edit",
            resetButton: "Reset",
        },
        edit: {
            title: "Edit Violation Rule",
            changeSeverity: "Change Severity",
            changeStatus: "Change Status",
        },
    },
    dashboardNewOrgPage: {
        gettingStarted: "Getting Started",
        platforms: "Low-Code platforms",
        blog: "Low-Code security blog",
        contactUs: "Have a question?",
    },
    mainDashboardPage: {
        openViolationsTitle: "Open Violations",
        openViolationsTooltip: "Summarizes all Open violations based on the severity",
        riskMappingScoreWidget: {
            title: "Resource Risk Score",
            tooltip: "Identifies the high risk & high business impact resources that require urgent attention",
            securityRisk: "Security Risk",
            securityRiskHoverMsg: "Evaluates all violations of a resource and selects the highest severity",
            businessCriticality: "Business Criticality",
            businessCriticalityHoverMsg: "Evaluates the potential business importance of a Flow, Application or Connection",
            criticalRisk: "Critical",
            highRisk: "High",
            mediumRisk: "Medium",
            lowRisk: "Low",
            minimalRisk: "Minimal",
            healthyRisk: "Healthy",
        },
        lowCodeNoCodeAdoptionTitle: "Low-Code/No-Code Adoption",
        lowCodeNoCodeAdoptionTooltip: "Displays the number of resources overtime",
        topOwaspMitreWidget: {
            title: "Top OWASP/MITRE",
            tooltip: "Groups all Violations issues into the OWASP/MITRE categories for Low-Code/No-Code by severity",
            categoriesTitle: "Categories",
            violationsTitle: "Violations",
        },
        passedAndFailedRulesTitle: "Passed & Failed Security Rules",
        passedAndFailedRulesTooltip: "Rules that triggered or did not trigger violations",
    },
    visibilityDashboardPage: {
        totalTitle: "Total",
        buildersAdoptionAndGrowthTitle: "Builders Adoption & Growth",
        topBuildersTitle: "Top Builders",
        topBuildersTooltip: "Identifies the Low-Code/No-Code champions in the organization, who built the most resources",
        topBuildersCreatorTitle: "Created By",
        topBuildersApplicationTitle: "Application",
        topBuildersAutomationTitle: "Automation",
        topBuildersAgentTitle: "Agent",
        topBuildersDataStorageTitle: "Data Storage",
        buildersAdoptionTitle: "New Builders Adoption",
        buildersAdoptionTooltip:
            "Displays how many new builders have participated in creation of new resources, grouped by the resource category in the last year",
        managementAndCleanupTitle: "Management & Clean-up",
        unusedResourcesTitle: "Unused Resources",
        unusedResourcesTooltip:
            "Identifies cases where a resources is no longer being used and could be a candidate for deletion, grouped by the resource category",
        orphanResourcesTitle: "Orphan Resources",
        orphanResourcesTooltip:
            "Identifies cases where a resource no longer has an owner and needs to be reassigned or deleted, grouped by the resource category",
        resourceAnalysisTitle: "Resource Analysis",
    },
    enterpriseAiDashboardPage: {
        openViolationsSeverityDistributionForAiTitle: "Plugins Risk Severity",
        openViolationsSeverityDistributionForAiTooltip:
            "Identifies the riskiest plugins in the organization, grouped by the severity of the violations",
        m365copilotPluginTypesDistributionTitle: "Plugin Types",
        m365copilotPluginTypesDistributionTooltip: "Identifies the most common plugin types in the organization",
        copilotsAdoptionTitle: "Usage Trends",
        copilotsAdoptionTooltip: "Displays the number of users and interactions with copilot in the entire organization overtime",
        owaspRiskDistributionForAiTitle: "Risk Distribution",
        owaspRiskDistributionForAiTooltip:
            "Identifies the riskiest OWASP categories in the organization that propose and immediate risk on ai plugins",
        m365copilotTopPluginsDisplayNameTitle: "Plugin Name",
        m365copilotTopPluginsTypeTitle: "Plugin Type",
        m365copilotTopPluginsInteractionsTitle: "Interactions",
    },
    menu: {
        dashboardPage: "Overview",
        visibilityPage: "Visibility",
        enterpriseAiPage: "Enterprise AI",
        enterpriseAiDetectionPage: "AI Runtime",
        integrationsPage: "Integrations",
        violationsPage: "Violations",
        hygienePage: "Hygiene",
        issuesPage: "Issues",
        policyPage: "Policies",
        settingsPage: "Settings",
        inventoryPage: "Inventory",
        apiDocsPage: "API Reference",
        changelogPage: "Release Notes",
        docsPage: "Docs",
        playbooksPage: "Playbooks",
        playbookPage: "Playbook",
        logout: "Log out",
        role: "Your role is",
    },
    tableActionsAndFilters: {
        actionsColumn: "Actions",
        category: "Category",
        type: "Type",
        resourceStatus: "Resource Status",
        environment: "Environment",
        platform: "Platform",
        firstSeenFilter: "First Seen",
        fromDate: "From",
        toDate: "To",
        createdSinceDate: "Created Since",
        timestampSinceDate: "From",
        createdUntilDate: "Created Until",
        timestampUntilDate: "To",
        firstSeenSinceDate: "First Seen Since",
        firstSeenUntilDate: "First Seen Until",
        searchBoxText: "Search...",
        lastChangedFilter: "Last Changed",
        severity: "Severity",
        integrationNameFilter: "Select Integrations",
        amountItemToShow: "Results per Page",
        customViewText: "Select pre-defined query...",
        lastExecutionSince: "Execution Since",
        lastExecutionUntil: "Execution Until",
        selectedRowsText: "rows on this page are selected.",
        expandResultsText: "Expand action to the filter result set",
        inventoryCustomViewDetails: {
            applicationsRecentlyModified: "Recently Modified Applications",
            automationsRecentlyModified: "Recently Modified Automations",
            newUsersCreation: "New Users",
            externalIdentities: "External Users",
            connectionCreatedFromCustomConnector: "Custom Connections",
            notInUseConnection: "Unused Connection",
            disabledConnections: "Inactive Connections",
            disabledAutomations: "Inactive Automations",
            inactiveUsers: "Inactive Users",
            automationUsesAiModel: "Automation Uses AI Model",
            teamsEnvironments: "Teams Environments",
            autonomousAgents: "Autonomous Agents",
            automationUsesWebhook: "Automations Using a Webhook",
            automationUsesHttpStepsWithoutAuthentication: "Automation Using HTTP Without Authentication",
            agentTriggers: "Agent Triggers",
            allBuilders: "All builders",
            orgWideAccess: "Org Wide Access",
            publicAccess: "Public Access",
        },
        violationsCustomViewDetails: {
            overSharedResources: "Over Shared Resources",
            nonCompliantConnections: "Non-Compliant Connections",
            insecureCommunication: "Insecure Communication",
            authenticationIssues: "Authentication Issues",
            customCode: "Custom Code",
            potentiallyRiskyDataFlow: "Potentially Risky Data Flow",
            suspiciousConfiguration: "Suspicious Configuration",
            untrustedGuestAccess: "Untrusted Guest Access",
            untrustedMemberAccess: "Untrusted Member Access",
        },
    },
    integrationsPage: {
        title: "Integrations",
        addButton: "CREATE NEW",
        integrationIdField: "Integration ID",
        copyIntegrationsId: "Copy ID",
        platformField: "Platform",
        environmentField: "Environment",
        integrationMethodField: "Integration Method",
        createdAtField: "Created at",
        createdByField: "Created By",
        lastChangedField: "Last Changed",
        lastChangedByField: "Last Changed By",
        lastScan: "Last Scan",
        scanDataNotFound: "Scan data not found",
        pending1stScanResults: "Pending 1st scan results",
        startedCollectingAt: "Started collecting at",
        errorFetchingScanFreshnessData: "Error fetching scan freshness data",
        status: "Status",
        maxIntegrationsMsg: "Your tenant has reached the maximum integrations quota",
        notAllowedToAddIntegrationMsg: "You do not have sufficient permissions to add an integration",
        deleteConfirmation: {
            title: "Delete integration",
            content: "Are you sure?<br>Deleting an integration will delete the associated policies, violations, hygiene issues and resources.",
        },
        integrationActions: {
            editAction: "Edit",
            enableAction: "Enable",
            disableAction: "Disable",
            deleteAction: "Delete",
            retryAction: "Retry",
        },
    },
    integrationPage: {
        editTitle: "Edit Integration",
        addTitle: "Add New Integration",
        integrationNameField: "Integration Name",
        createButton: "CREATE",
        saveButton: "SAVE",
        cancelButton: "CANCEL",
        addModePlatformField: "Select Platform",
        editModePlatformField: "Platform",
        addModeEnvironmentField: "Select Environment",
        editModeEnvironmentField: "Environment",
        addModeAuthMethodField: "Select Method",
        editModeAuthMethodField: "Method",
        platformDropDownPlaceHolder: "More Platforms",
        errorMessageOnUpdateCredentials: "Something went wrong - could not update credentials",
        errorMessageOnUpdate: "Something went wrong",
        authDetails: {
            apiKeyMethod: "API key",
            userPasswordMethod: "User/Password",
            certWithUserPasswordMethod: "Client Certificate & User/Password",
            oauthMethod: "OAuth Authorization Code",
            oktaSsoMethod: "Okta SAML based SSO",
            apiTokenMethod: "API token",
            servicePrincipalMethod: "Service Principal",
            ppZenityMultiTenantAppServicePrincipalMethod: "Managed Application Consent",
            oauthClientCredentialsFlowMethod: "OAuth Client Credentials flow",
            apiKeyFieldKey: "API key",
            emailFieldKey: "Email",
            usernameFieldKey: "Username",
            passwordFieldKey: "Password",
            tenantIdFieldKey: "Tenant id",
            clientIdFieldKey: "Client id",
            oktaAppEmbeddedUrlFieldKey: "Okta application embedded link",
            oktaUsernameFieldKey: "Okta username",
            oktaPasswordFieldKey: "Okta password",
            servicePrincipalSecretFieldKey: "Service principal secret",
            clientCertificateThumbprintFieldKey: "Client certificate thumbprint",
            clientCertificatePrivateKeyFieldKey: "Client certificate private key",
            salesforceInstanceUrlFieldKey: "Salesforce instance URL",
            apiTokenFieldKey: "API token",
            clientSecretFieldKey: "Client Secret",
            servicePrincipalObjectIdFieldKey: "Service principal object id",
            serviceNowInstanceUrlFieldKey: "ServiceNow instance URL",
            workspaceIdFieldKey: "Workspace id",
        },
        authDescriptions: {
            ppUserPasswordUsername: "Power Platform Administrator login email address",
            ppUserPasswordPass: "Power Platform Administrator login password",
            ppTenantId: "Azure Active Directory tenant ID",
            ppClientId: "Azure Active Directory application ID (specified under Enterprise Applications)",
            ppServicePrincipalSecret: "Azure Active Directory application secret (specified under App Registrations)",
            ppClientCertificateThumbprint: "Azure Active Directory application certificate thumbprint (specified under App Registrations)",
            ppClientCertificatePrivateKey: "The private key of the application certificate",
            workatoUserPasswordUsername: "Workato team owner or admin login email address",
            workatoUserPasswordPass: "Workato team owner or admin login password",
            workatoApiKeyEmail: "Workato team owner or admin login email address",
            workatoApiKeyKey: "Workato account API key",
            workatoApiToken: "Workato client API token",
            oktaAppEmbeddedUrl: "Okta application embedded link",
            oktaUsername: "The username to sign in to Okta application",
            oktaPassword: "The password to sign in to Okta application",
            salesforceInstanceUrl: "A URL indicating the Salesforce instance of the organization",
            salesforceUsername: "Username in the Salesforce organization authorized to the Connected App",
            salesforceClientId: "Salesforce Connected App Consumer Key (also known as Client id)",
            salesforceClientSecret: "Salesforce Connected App Consumer Secret (also known as Client Secret)",
            salesforceCertificatePrivateKey: "Private key of a Certificate associated with the Salesforce Connected App",
            servicePrincipalObjectId: "The object id of the service principal of Zenity multi-tenant app",
            serviceNowInstanceUrl: "A URL indicating the ServiceNow instance of the organization",
            serviceNowClientId: "ServiceNow client ID",
            serviceNowSecretId: "ServiceNow client secret",
            chatGptEnterpriseWorkspaceId: "ChatGPT Enterprise Workspace ID",
            chatGptEnterpriseApiKey: "ChatGPT Enterprise Workspace API key",
        },
    },
    policyPage: {
        config: {
            generalTab: "General",
            trustedDomainsTab: "Trusted Domains",
            connectorsTab: "Connectors",
            environmentsTab: "Environments",
            endpointFilteringTab: "Endpoint Filtering",
            settings: "Settings",
            connectorsContent: {
                description:
                    "Connectors are API wrappers meant to allow data access from the source platform to 3rd parties.\nZenity categorizes these connectors to be later used in our Data Leak Prevention policies.\nA simple example would be to flag any movement from 'Social-Media' to a 'High-Risk' Connector, that the Zenity user can define.",
            },
            trustedDomainsContent: {
                allowedDomains: "Allowed Domains",
                allowedDomainsDesc:
                    "Describes the Organization domain.\n Zenity uses the email domain in our rule engine to detect various scenarios such as: Data Leak or if an external user has access to your platform and more.",
                domainsList: "Domains List",
                addDomain: "Add Domain",
                newDomain: "New Domain",
                addMore: "Add More",
                enterDomain: "Enter Domain...",
                deleteDomain: "Delete Domain",
            },
            endpointFilteringContent: {
                allowedEndpoints: "Allowed Endpoints",
                allowedEndpointsDesc:
                    "Lists the organization's allowed endpoints.\n Zenity uses these endpoints in our rule engine to detect if a resource is communicating with an endpoint outside of the allowed list.",
                addEndpoint: "Add Endpoint",
                addMore: "Add More",
                enterEndpoint: "Enter endpoint...",
                deleteEndpoint: "Delete Endpoint",
                protocol: "Protocol",
                addEndpointsDescription:
                    "Enter the desired endpoint URL, which may include wildcards at the end of the path (e.g 'http://example.com/path/*').",
                invalidEndpoint: "The endpoint must consist of a valid domain and optionally a path and a protocol. e.g 'http://example.com/path'",
                enterUniqueEndpointsMsg: "Please enter unique endpoints",
            },
            generalSettingsContent: {
                policyName: "Policy Name",
                policyNameDesc: "You can change the policy name",
                policyType: "Policy Type",
                allowedNumberOfBuilders: "Allowed Number of Builders",
                allowedNumberOfBuildersDesc:
                    "Zenity detects cases where the number of flow builders\n is greater than the allowed number of builders\n to minimize the risk for a potential business disruption.",
                highNumberOfPrivilegedUsers: "High Number of Privileged Users in the Environment",
                highNumberOfPrivilegedUsersDesc:
                    "Zenity detects cases where the number of privileged users in the environment\n is greater than the defined number of high privileged users threshold\nto minimize the risk for a potential business disruption.",
                criticalNumberOfPrivilegedUsers: "Critical Number of Privileged Users in the Environment",
                criticalNumberOfPrivilegedUsersDesc:
                    "Zenity detects cases where the number of privileged users in the environment\n is equal or greater than the defined number of critical privileged users threshold to minimize the risk for a potential business disruption.",
                allowedConnectionsToProd: "Allow connections to Production",
                allowedConnectionsToProdDesc: "Zenity detects and alerts in case a non-production connection\n is used in a production environment",
                allowedConnectionsToNonProd: "Allow connections to Non-Production environments",
                allowedConnectionsToNonProdDesc:
                    "Zenity detects and alerts in case a production connection is used\n in a non-production environment",
                allowedIdentityProviders: "Allowed Identity Providers for Power Pages",
                allowedIdentityProvidersDesc: "Zenity detects usage of identity providers which are not trusted by the organization",
                allowedNumOfPrivilegedIdentitiesInWorkspace: "Allowed Number of Privileged Identities in Workspace",
                allowedNumOfPrivilegedIdentitiesInWorkspaceDesc:
                    "Zenity detects cases where the total number of privileged identities (Contributor, Member, Admin) of a workspace is greater than the defined number of privileged identities threshold.",
                allowedNumOfPrivilegedIdentitiesToDashboard: "Allowed Number of Privileged Identities to Dashboard",
                allowedNumOfPrivilegedIdentitiesToDashboardDesc:
                    "Zenity detects cases where the total number of privileged identities (Reshare, Build) of a Dashboard is greater than the defined number of privileged identities threshold.",
                allowedNumOfPrivilegedIdentitiesToDataset: "Allowed Number of Privileged Identities to Dataset",
                allowedNumOfPrivilegedIdentitiesToDatasetDesc:
                    "Zenity detects cases where the total number of privileged identities (Reshare, Build) of a Dataset is greater than the defined number of privileged identities threshold.",
                allowedNumOfPrivilegedIdentitiesToReport: "Allowed Number of Privileged Identities to Report",
                allowedNumOfPrivilegedIdentitiesToReportDesc:
                    "Zenity detects cases where the total number of privileged identities (Reshare, Build) of a Report is greater than the defined number of privileged identities threshold.",
                allowedNumOfPrivilegedIdentitiesToAgent: "Allowed Number of Privileged Identities to Agent",
                allowedNumOfPrivilegedIdentitiesToAgentDesc:
                    "Zenity detects cases where the total number of privileged identities to an Agent is greater than the defined number of privileged identities threshold.",
                allowedNumOfPrivilegedIdentitiesToGpt: "Allowed Number of Privileged Identities to GPT",
                allowedNumOfPrivilegedIdentitiesToGptDesc:
                    "Zenity detects cases where the total number of privileged identities to GPT is greater than the defined number of privileged identities threshold.",
                allowedNumOfPrivilegedIdentitiesToAiSkill: "Allowed Number of Privileged Identities to AI Skill",
                allowedNumOfPrivilegedIdentitiesToAiSkillDesc:
                    "Zenity detects cases where the total number of privileged identities to AI Skill is greater than the defined number of privileged identities threshold.",
                allowedIdentityProvidersPlaceholder: "Select Identity Providers...",
                effectivePolicySettingsTitle: "Effected Rules",
                effectivePolicySettingsRuleId: "Rule ID",
                effectivePolicySettingsRuleName: "Rule Name",
            },
        },
        morePolicies: "Custom policies",
        disabledAddPolicyReachedMaxMsg: "You've reached the maximum number of policies",
        disabledAddPolicyNoPermissionMsg: "You do not have sufficient permissions to add a policy",
        addPolicy: "Add policy",
        duplicatePolicy: "Duplicate policy",
        enterPolicyName: "Enter policy name",
        duplicationMessage: "Duplicate will copy the entire policy configuration excluding the Environments association",
        deletePolicy: "Delete Policy",
        noPoliciesFoundMsg: "No policies found",
        policy: {
            violationRulesTab: "Rules",
            hygieneRulesTab: "Hygiene Rules",
            exemptionRulesTab: "Exemption Rules",
            configurationTab: "Configuration",
            inLineControlRulesTab: "In-Line Control",
            violationRules: {
                groupName: "Group name",
                groupBy: "Group by",
                tags: "Tags",
                status: "Status",
                severity: "Severity",
                none: "None",
                owasp: "OWASP LCNC",
                mitre: "MITRE ATT&CK",
                owaspLlm: "OWASP LLM",
                genAiMatrix: "MITRE ATLAS (GenAI Matrix)",
                tableColumns: {
                    ruleName: "Rule Name",
                    ruleId: "Rule ID",
                    ruleTags: "Rule Tags",
                    violations: "Count",
                    category: "Category",
                    severity: "Severity",
                    status: "Status",
                },
                dialogsLabels: {
                    statusChangedTitle: "Severity / Status change",
                    resetTitle: "Reset Rule",
                    statusChangedMessageContent: "Are you sure you want to change the configuration of this policy?",
                    resetMessageContent: "Are you sure you want to reset this rule?",
                },
            },
            environments: {
                title: "Environments list",
                tableColumns: {
                    environmentName: "Environment name",
                    createdBy: "Created By",
                    createdAt: "Created At",
                    resources: "Resources",
                    status: "Status",
                },
                associatedWith: "Associated with ",
                associationDescription: "Remove 1st to associate with a new policy",
            },
            inLineControlRules: {
                tableColumns: {
                    ruleName: "Rule Name",
                    ruleId: "Rule ID",
                    detections: "Detections",
                    severity: "Severity",
                    detection: "Detection",
                    prevention: "Prevention",
                    status: "Status",
                },
            },
        },
    },
    enterpriseAiDetectionPage: {
        tabs: {
            activity: "Activity",
            activitySubtitle: `This page shows real-time AI activity within the organization, broken down into individual "steps." <br> Each step represents a user or AI action within an "AI thread", providing a transparent, detailed view of AI interactions and autonomous operations.`,
            activityTooltip: "Zenity retains three months of your runtime data and activity.",
            findings: "Findings",
            findingsTooltip: "Zenity retains three months of your runtime data and findings.",
            findingsSubtitle: "Below are security findings based on real time digest of your AI activity.",
            prevention: "Prevention",
            preventionSubtitle: "Prevention",
            preventionTooltip: "Prevention",
            dataInsights: "Data Insights",
            inLineControl: "In-Line Control",
            inLineControlSubtitle: `Monitor real-time enforcement actions taken directly within AI workflows. <br>Backed by AI Edge and AIDR, this includes proactive blocking, behavior-based detection, and policy-driven control of agent activity as it happens.`,
        },
    },
    userManagementPage: {
        tabs: {
            users: "Users",
            api: "API",
        },
        usersPage: {
            title: "Users",
            inviteUser: "Invite user",
            tableColumns: {
                name: "User name",
                email: "Email",
                createdAt: "Created at",
                lastLogin: "Last login",
                role: "Role",
            },
            deleteUserTitle: "Delete user",
            roleModificationTitle: "Role Modification",
            roleModificationBody: "Are you sure you want to modify user's role?",
            inviteUserTitle: "Invite user",
            deleteUsersMultiActionName: "Delete Users",
            inviteUserEmailTitle: "User email",
            inviteUserEmailPlaceholder: "Enter an email",
            inviteUserRoleTitle: "User role",
            inviteUserRolePlaceholder: "Select a role...",
            authenticationTitle: "Authentication",
            authenticationPlaceholder: "Select an authentication...",
        },
        apisPage: {
            clientIdTitle: "Client ID",
            clientIdDescription: "The Zenity cross-platform account id, used when authenticating with the Zenity API",
            clientSecretTitle: "Client Secret",
            clientSecretRotation: "Rotate Secret",
            clientSecretDescription: "The Zenity API secret, used together with the 'Client ID' when authenticating with the Zenity API",
            notFoundText: "No API credentials for this Account",
            areYouSureTitle: "Client Secret Rotation",
            areYouSureBody: "Are you sure you want to rotate your client secret?",
            secretRotationSucceeded: "Client secret rotation succeeded",
        },
    },

    integrationStatus: {
        activeStatus: "Active",
        disabledStatus: "Disabled",
        inactiveStatus: "Inactive",
    },
    policiesPage: {
        title: "Policies",
        selectIntegrationPlaceHolder: "Select integration...",
        nameCol: "Policy Name",
        idCol: "Policy ID",
        severityCol: "Severity",
        platformCol: "Platform",
        environmentCol: "Environment",
        violationsCol: "Violations",
        statusCol: "Status",
        toggleConfirmationTitle: "Status change",
        toggleConfirmationContent: "Are you sure you want to change the status of these policies?",
        updatingButtonText: "Updating...",
        updateButtonText: "Update",
        deleteButtonTextHoverText: "Deleting is disabled, the list must have at least one endpoint",
    },
    issuesPage: {
        name: "Issues",
        gridColumns: {
            name: "Issue",
            severity: "Severity",
            primaryResource: "Primary Resource",
            ownerCreatedBy: "Owner / Created By",
            labels: "Labels",
            status: "Status",
        },
        issueOverviewTab: "Overview",
        issueRemidationTab: "Remediation",
        idTitle: "Id:",
        issueAnalysis: "Issue Analysis",
        issueTimeLine: "Timeline",
        timelineIssueCitations: "Citations:",
        relatedFinding: {
            description: "Findings",
            type: "Type",
            timestamp: "Timestamp",
            severity: "Severity",
            user: "User",
            link: "Link",
            tags: "Tags",
        },
        fetchTimelineMessagesContentButton: "Fetch Messages Content",
        actionDialogLabels: {
            fileName: "File Name",
            fileSize: "File Size",
            scanResults: "Scan Results",
            uploadDate: "Upload Date",
        },
        quarantineUserDialog: {
            tableColumns: {
                name: "Name",
                email: "Email",
                role: "Role",
            },
            executeActionsButton: "EXECUTE ACTIONS",
        },
    },
    hygienePage: {
        title: "violations",
        gridColumns: {
            violationName: "Violation Name",
            labels: "Labels",
            resourceName: "Resource Name",
            owasp: "OWASP",
            policyId: "Policy ID",
            resourceType: "Type",
            createdBy: "Created By",
            ownedBy: "Owned By",
            ruleTags: "Rule Tags",
            platform: "Platform",
            resourceStatus: "Resource Status",
            severity: "Severity",
            firstSeen: "First Seen",
            violationStatus: "Violation Status",
        },
        filters: {
            search: "Search by violation name or rule id",
        },
    },
    violationsPage: {
        title: "Violations",
        gridColumns: {
            violationName: "Violation Name",
            labels: "Labels",
            resourceName: "Resource Name",
            owasp: "OWASP",
            policyId: "Policy ID",
            resourceType: "Type",
            createdBy: "Created By",
            ownedBy: "Owned By",
            ruleTags: "Rule Tags",
            platform: "Platform",
            resourceStatus: "Resource Status",
            severity: "Severity",
            firstSeen: "First Seen",
            violationStatus: "Violation Status",
        },
        checkboxes: {
            showExempted: "Show exempted",
        },
        filters: {
            search: "Search by violation name or rule id",
        },
    },
    supportPage: {
        tickets: {
            new_ticket_title: "New Ticket",
            title: "Title",
            description: "Description",
            type: "Type",
            severity: "Severity",
            phone_number: "Phone Number",
            uploadFileWarning: `Please do not upload files containing sensitive data. Limited to ${MaxNumberOfSupportFiles} files, each file size is limited to maximum ${MaxSupportFileSizeInMB} MB. Supported file formats: png, jpeg, jpg, txt, json.`,
            successMessage: "Support ticket was created. An email was sent to your mailbox.",
            criticalTicketWarning: `I hereby acknowledge the following. Opening a critical ticket requires 24x7 availability in the provided credentials till ticket resolution or severity change. In case we will not be able to reach you the severity of the ticket will be changed to Major.`,
            severityLabels: {
                low: "Low - Small product issue or a question",
                minor: "Minor - General support issues",
                major: "Major - Production related issue",
                critical: "Critical - Major Production feature does not work",
            },
        },
    },
    violationActions: {
        exempt: "Exempt",
        waive: "Waive",
    },
    AiDataInsightsActions: {
        exclude: "Exclude from RAG",
        include: "Include in RAG",
    },
    commonActions: {
        sendEmail: "Send Email",
        delete: "Delete",
        isolate: "Isolate",
        addOwner: "Add Co-Owner",
        removeOwner: "Remove Co-Owner",
        setAccess: "Set Access",
        disable: "Disable",
        enable: "Enable",
        getFlowDefinition: "Get Raw Resource",
        getResourceSbomFile: "Generate SBOM",
        view: "View",
        agentActionEnforceUserConfirmation: "Enforce End-User Confirmation",
        agentActionEnforceUserAuthentication: "Enforce End-User Authentication",
        sendEmailAction: {
            contactMaker: "Contact Maker",
            to: "To",
            subject: "Subject",
            body: "Body",
            contactMakerDisabledTooltip: "Maker is not found",
        },
        quarantine: "Quarantine",
        unquarantine: "Unquarantine",
        sendWebhookAction: {
            url: "URL",
            token: "Secret",
        },
        addOwnerAction: {
            disclaimer: "Changes will be applied immediately and be reflected in Zenity within 24h",
            newOwnerEmail: "New Co-Owner Email",
            openPlatformOnSuccess: "Open Platform On Success",
        },
        addLabelAction: {
            chooseLabelTitle: "Add Labels",
            writeDescriptionTitle: "Description (optional)",
        },
        removeOwnerAction: {
            ownerEmailToRemove: "Co-Owner Email To Remove",
        },
        secureFlowStepsAction: {
            title: "Secure Flow Steps",
            supportedRulesHeader: "Supported Rules",
            limitationsHeader: "Limitations",
            limitationsDisclaimer:
                "The action supports 'Unmanaged Solution Aware' flows, meaning they are in a solution that is not managed. This ensures the integrity and stability of managed solutions is maintained. Due to a limitation in the PowerPlatform API, this is not yet possible for non-solution aware flows.",
            actionOverviewHeader: "Action Overview",
            actionOverviewTitle: "This action automatically addresses a critical security concern:",
            actionOverviewDescription: {
                sensitiveData:
                    "Power Automate flows that log sensitive data in plain text, potentially exposing it to unauthorized users. Zenity identifies and secures these steps by enabling data masking, ensuring the information is encrypted and protected.",
            },
            howItWorksHeader: "How It Works:",
            howItWorksDescription:
                "The action is triggered by specific violation rules that detect risky flows. It targets only the flow steps identified as risky, preserving the ability to debug the rest of the flow as needed.",
        },
        manageAccessAction: {
            manageAccess: "Set Access",
            disclaimer: "Changes will be applied immediately and be reflected in Zenity within 24h",
            openPlatform: "Open Platform",
            fetchingPermissionsFromPlatform: "Fetching Permissions From Platform",
            revokeAccessSelected: "Remove Access",
            isolateResourceButtonLabel: "Isolate Resource",
            isolateResourceButtonTooltip: "Removes access permissions for this resource to all users, except the owner.",
        },
        enforceUserAuthenticationAction: {
            title: "Enforce End-User Authentication",
            content: "Zenity will modify the agent's action configuration to enforce end-user authentication",
        },
        enforceUserConfirmationAction: {
            title: "Enforce End-User Authentication",
            content: "Zenity will modify the agent's action configuration to enforce end-user confirmation before action execution",
        },
        download: {
            title: "Download",
            successMessage: "Download completed successfully",
            errorMessage: "Download failed",
        },
        isolateGptAction: {
            title: "Isolate GPT",
            content: "Zenity will remove access permissions for this GPT to all users, except the owner.",
        },
        deleteGptCanvas: {
            title: "Delete Canvas",
            content: "Deletion of a user's canvas.",
        },
        getGptCanvas: {
            title: "Get Canvas",
            content: "Deletion of a user's canvas.",
        },
        getGptKnowledge: {
            title: "Download",
            content: "Download the selected knowledge file from the GPT.",
        },
        deleteGptConversationAction: {
            title: "Delete Agent Thread",
            content: "This action will permanently delete the thread (conversation) in which is step is part of.",
        },
        disableCopilotAction: {
            title: "Disable Agent Action",
            content: "Zenity will modify the agent's action status to 'Disabled'",
        },
        manageSecureFlowStepsSolutionAwareAction: {
            title: "Confirmation",
            content: "Zenity is going to mask the sensitive data found, by enabling the 'Secure Input/output' setting on the relevant flow steps",
        },
        waitAction: {
            waitTime: "Wait Time",
        },
        stop: "Stop",
        start: "Start",
        secureFlowSteps: "Secure Flow Steps",
        adminActionTooltip: "This action is allowed for Admin only.",
        operatorActionTooltip: "This action is allowed for Operator only.",
        disabledResourceActionTooltip: "Supports only active flows.",
        deletedResourceTooltip: "This resource was deleted.",
        getResourceDefinitionAction: {
            inactiveIntegrationMsg: "The integration must be active to perform this action.",
            sensitiveDataDisclaimerPopupTitle: "Confirmation",
            sensitiveDataDisclaimer:
                "The resource may contain sensitive data. <br>Are you sure you want to continue? <br>Zenity does not store this data in any way, the resource is retrieved in real-time for display purposes only.",
        },
        getFlowDefinitionAction: {
            rawJsonDescription: "Use the raw JSON of the flow to investigate every aspect of the flow without going to the source platform.",
            title: "Flow Raw Resource",
        },
        getRawResourceAction: {
            actionName: "Get Raw Resource",
            getRawResourceSpecificResourceTypeText: {
                rawJsonDescription:
                    "Use the raw JSON of the {0} resource to investigate every aspect of the {0} without going to the source platform.",
                title: "{0} Raw Resource",
            },
        },
        powerplatformSetCopilotAuthentication: {
            actionName: "Set Authentication",
            title: "Available Authentication Methods",
            noAuthentication: "No Authentication",
            noAuthenticationDescription: "Allows anonymous users (anyone) to communicate with the Agent (risky)",
            permittedUsersOnly: "Only for Teams and PowerApps",
            permittedUsersOnlyDescription: "Enforces AAD authentication & restricts org-wide access (preferred)",
            signinRequiredCustomWebsite: "Requires users to sign in (Manual authentication only)",
            signinRequiredCustomWebsiteDescription: "Custom authentication, enforces user sign in & restricts org-wide access (preferred)",
            applyButton: "Apply",
            disclaimer1: "Changes will be applied based on the Agent 'Published status'.",
            disclaimer2: "Published Agent will be published again to enforce changes.",
            disclaimer3: "Unpublished Agents will not be published.",
        },
        removePermissionsPlaybookAction: {
            title: "Remove Permissions",
            orgWideAccess: "Org-Wide Access",
            disclaimer: "Removes tenant-wide access from an agent",
        },
        isolateResourcePlaybookAction: {
            description: "This action removes access to this resource for all users except the owner.",
        },
        removeAccessPlaybookAction: {
            title: "Remove Access",
            supportedRulesAndLimitationsHeader: "Supported Rules",
            supportedRulesHeader: "Supported Rules",
            limitationsHeader: "Limitations",
            limitationsDisclaimer:
                "In case you are trying to remove access for a guest user who is also the primary owner of the resource, that is currently not supported in the PowerPlatform API.",
            actionOverviewHeader: "Action Overview",
            actionOverviewTitle: "This action automatically addresses two primary security concerns:",
            actionOverviewDescription: {
                guestAccess:
                    "Guest Access : Zenity identifies and removes guest user access, except in the case specified under the 'Limitations' section.",
                tenantWideAccess: "Tenant-Wide Access: Zenity identifies & eliminates access to resources that are shared across the entire tenant.",
            },
            howItWorksHeader: "How It Works:",
            howItWorksDescription:
                "The action is triggered by specific rules that you configure. Once triggered, it assesses the type of access violation—either guest access or tenant-wide access and removes it accordingly. For detailed rules and scenarios, refer to the section below.",
        },
        getSbomFileAction: {
            noSbomAttachmentMsg: "Currently supported for Canvas Apps with PCF components",
        },
        getFlowRunsAction: {
            displayName: "Get Latest Flow Runs",
            dialogTitle: "Flow Runs (Trigger inputs and outputs only)",
            dialogDescription: "Use the flow runs to understand what the flow does without going to the source platform.",
            confirmationPopupTitle: "Confirmation",
            confirmationPopupContent:
                "The flow runs may contain sensitive data. <br>Are you sure you want to continue? <br>Zenity does not store this data in any way, <b>the flow trigger inputs and outputs</b> are retrieved in real-time for display purposes only.",
        },
        issueActions: {
            setAgentActionAuth: "Set Agent Action Auth",
            quarantineUser: "Quarantine User",
            contactDataOwner: "Contact Data Owner",
            routeToSOC: "Route to SOC",
            excludeFromRAG: "Exclude from RAG",
            restrictTriggerDomains: "Restrict Trigger Domains",
            contactOwner: "Contact Owner",
            disableAIAgentAction: "Disable AI Agent Action",
            deleteConnection: "Delete Connection",
            maskCredentials: "Mask Credentials",
            removeAccess: "Remove Access",
            disableMemories: "Disable Memories",
        },
        chatGptEnterpriseDeleteConversationAction: "Delete Agent Thread",
        deleteAction: {
            confirmationText: "Permanent delete",
        },
    },
    errors: {
        401: "401 - Unauthorized error",
        403: "403 - Forbidden",
        404: "404 - Not found",
        422: "422 - Unprocessable Entity error",
        generic:
            "An unknown error has occurred, we have notified our engineers. Please try again and if the problem persists, reach out to support@zenity.io.",
        inventory404ResourceMightBeDeletedError: "404 - The resource was not found. It might have been deleted from the platform.",
    },
    labelsDialog: {
        setLabelsTitle: "Set Labels",
        searchLabels: "Search...",
        systemLabelsTitle: "System Labels",
        noSystemLabelsMsg: "No system labels defined",
        customLabelsTitle: "Custom Labels",
        noCustomLabelsMsg: "No custom labels defined, create new ones",
        createNewLabel: "Create a new label",
        justificationTitle: "Description",
    },
    createLabelDialog: {
        createLabelTitle: "Create a New Label",
        newLabelNameTitle: "Name",
        newLabelColorTitle: "Select a Color",
        createButtonText: "Create",
    },
    editLabelDialog: {
        editLabelTitle: "Edit Label",
        newLabelNameTitle: "Name",
        newLabelColorTitle: "Select a Color",
        deleteButtonText: "Delete",
        editButtonText: "Save",
    },
    deleteLabelDialog: {
        deleteLabelTitle: "Delete Label",
        deleteLabelContent: "This will remove this label. You should remove it from all violations labeled with it before deleting it.",
        deleteLabelButtonText: "Delete Label",
    },
    violationPage: {
        violationStatusTitle: "Violation Status:",
        firstSeenTitle: "First seen:",
        lastSeenTitle: "Last seen:",
        idTitle: "ID:",
        labels: "Set Labels",

        violationTabTitle: "Violation",
        notesTabTitle: "Notes",
        auditsTabTitle: "Audit Events",
        addJustificationButton: "Add Justification",
        addNoteButton: "Add Note",
        deleteNoteButton: "Delete",
        deleteNoteConfirmationTitle: "Delete note",
        deleteNoteConfirmationContent: "Are you sure?<br>This action can't be undone.",
        noteTextAreaPlaceholder: "Type a note...",

        summaryCardTitle: "What happened?",
        summaryCardFieldResourceName: "Resource Name",
        summaryCardFieldResourceCategoryAndType: "Category & Type",
        summaryCardFieldResourceStatus: "Resource Status",
        summaryCardFieldPlatformResourceId: "Platform Resource ID",
        summaryCardFieldCreated: "Created",
        summaryCardFieldLastUsed: "Last Used",
        summaryCardFieldLastModified: "Last Modified",
        summaryCardFieldEnvironment: "Environment",
        summaryCardFieldResourceCreatedBy: "Resource Created By",
        summaryCardFieldResourceOwnedBy: "Resource Owned By",
        summaryCardFieldRuleId: "Rule Id",
        summaryCardExploreResourcePlatformLink: "Explore in platform",
        summaryCardExploreResourceInventoryLink: "Explore in Inventory",
        summaryCardExploreResourceInventoryLinkDisabled: "Resource is not in the inventory because it was deleted from the platform.",

        graphCardTitle: "Graph",
        graphMessageResourceDeleted: "Graph is not available for deleted resources.",

        riskReasonCardTitle: "Why is this a risk?",
        riskReasonCardCategoryFieldKey: "Category",
        riskReasonCardAttackFieldKey: "GenAI Matrix",
        riskReasonCardLlmOwaspFieldKey: "OWASP LLM",
        riskReasonCardLcncOwaspFieldKey: "OWASP LCNC",

        triageSuggestionTitle: "How to triage?",
        fixSuggestionTitle: "How to fix?",
        nextStepsTitle: "What should I do now?",

        findingsCardTitle: "Findings",
        singlefindingCardTitle: "Finding",
    },
    formErrors: {
        genericFormErrorMsg: "Some fields are missing or contain invalid inputs",
        signInRequiredFormErrorMsg: "Signing into platform is required",
        emailFormFieldMsg: "Please enter a valid Email address",
        guidFormFieldMsg: "Please enter a valid GUID",
        noSpaceFormFieldMsg: "Please enter a valid value without spaces",
        requiredFormFieldMsg: "Field is required and can't be left empty",
        certificateThumbprintFormFieldMsg: "Please enter a valid certificate thumbprint",
        certificatePrivateKeyFormFieldMsg: "Please enter a valid certificate private key, including start prefix and end suffix",
        salesforceInstanceUrlFormFieldMsg: "Please enter a valid Salesforce instance URL",
        serviceNowInstanceUrlFormFieldMsg: "Please enter a valid ServiceNow instance URL",
        chatGptEnterpriseApiKeyFormFieldMsg: "Please enter a valid ChatGPT Enterprise API key",
    },
    common: {
        found: "Found",
        confirm: "Confirm",
        cancel: "Cancel",
        save: "Save",
        create: "Create",
        on: "On",
        off: "Off",
        ok: "OK",
        yes: "Yes",
        no: "No",
        add: "Add",
        list: "List",
        select: "Select",
        noThanks: "No, Thanks",
        notAvailable: "N/A",
        notApplicable: "Not Applicable",
        yesDelete: "YES, DELETE",
        duplicate: "Duplicate",
        invite: "Invite",
        by: "by",
        at: "at",
        insufficientData: "Insufficient Data",
        comingSoon: "Coming Soon",
        high: "High",
        medium: "Medium",
        low: "Low",
        healthy: "Healthy",
        safe: "Safe zone",
        reset: "Reset",
        mediumRisk: "Medium risk",
        highRisk: "High risk",
        lowRisk: "Low risk",
        criticalRisk: "Critical risk",
        export: "EXPORT CSV",
        violationsBulkTooltip: "Limited to 10,000 rows.\n Action will execute on the first results only, according to the sort order.",
        violationsExportToolTip: "Limited to 10,000 rows.\nOnly the first ones will be exported, according to the sort order.",
        inventoryExportToolTip: "Limited to 10,000 rows.\nOnly the first ones will be exported, according to the sort order.",
        name: "Name",
        backTo: "Back to",
        edit: "Edit",
        settings: "Settings",
        properties: "Properties",
        createdBy: "Created By",
        ownedBy: "Owned By",
        startTime: "Start Time",
        endTime: "End Time",
        log: "Log",
        logs: "Logs",
        areYouSureMessage: "Are you sure you want to delete the following?",
        uploadFiles: "Upload Files",
        text_input_placeholder: "Enter your text...",
        description_input_placeholder: "Enter description",
        wasDeletedSuccessfully: "was deleted successfully",
        tenantLevelResource: "Tenant Level Resource",
        platformGenerated: "Platform Generated",
        dueTo: "due to",
        noData: "No Data to Display",
        maximumItemsSelectionReached: "maximum of {0} selected items is reached",
        statusActive: "Active",
        statusInactive: "Inactive",
    },
    identityTypes: {
        system: "SYSTEM",
    },
    inventoryResourcePage: {
        statusTitle: "Status:",
        idTitle: "ID:",

        overviewTabTitle: "Overview",
        relationsTabTitle: "Relations",
        violationsTabTitle: "Violations",
        hygieneTabTitle: "Hygiene",

        infoCardTitle: "Info",
        infoCardGraphTitle: "Graph",
        infoCardResourceCategoryFieldKey: "Resource Category",
        infoCardResourceDescriptionFieldKey: "Resource Description",
        infoCardInstructionsFieldKey: "Instructions",
        infoCardWebBrowsingCapabilityFieldKey: "Web Browsing Capability",
        infoCardResourceTypeFieldKey: "Resource Type",
        infoCardPlatformResourceIdFieldKey: "Platform Resource ID",
        infoCardCreatedByFieldKey: "Created By",
        infoCardOwnedByFieldKey: "Owned By",
        infoCardOrgWideAccessFieldKey: "Org - Wide Accessible",
        infoCardPublicAccessFieldKey: "Publicly Accessible",
        infoCardResourcePublicationStatusFieldKey: "Publication Status",
        infoCardResourceVersionFieldKey: "Version",
        infoCardUserAccessAmountFieldKey: "Number of shared users",
        infoCardResourceBusinessCriticalityFieldKey: "Business Criticality",
        infoCardResourceSecurityRiskFieldKey: "Security Risk",

        infoCardAutomationTypeFieldKey: "Automation Type",
        infoCardAutomationStatusFieldKey: "Automation Status",
        infoCardAutomationLastRunStatusFieldKey: "Last Run Status",
        infoCardAutomationStepsCountFieldKey: "Steps Count",
        infoCardAutomationUsesAiModelFieldKey: "Uses AI model",
        infoCardAutomationIsSolutionAwareFieldKey: "Is Solution Aware",
        infoCardAutomationIsBotTriggerFieldKey: "Is Agent Trigger",

        infoCardIdentityTypeFieldKey: "Identity Type",
        infoCardIdentityProviderIdFieldKey: "Identity Provider Id",
        infoCardIdentityEmailFieldKey: "Email Address",
        infoCardIdentityDepartmentFieldKey: "Department",
        infoCardIdentityIsActiveFieldKey: "Is Active",
        infoCardIdentityIsExternalFieldKey: "Is External",
        infoCardIdentityIsBuilderFieldKey: "Is Builder",

        infoCardConnectorProviderNameFieldKey: "Provider Name",
        infoCardConnectorProviderCategoryFieldKey: "Provider Category",
        infoCardConnectorVersionFieldKey: "Version",
        infoCardConnectorBackendServiceUrlFieldKey: "Backend Service Url",
        infoCardConnectorIsDeprecatedFieldKey: "Is Deprecated",

        infoCardConnectionInUseFieldKey: "Is Connection in Use",
        infoCardConnectionStatusFieldKey: "Connection Status",
        infoCardConnectionAccountFieldKey: "Connection Account",
        infoCardConnectionHostNameFieldKey: "Connection Host Name",
        infoCardConnectionIsOnPremisesFieldKey: "Is On Premises",
        infoCardConnectionAuthenticationMethodFieldKey: "Authentication Method",
        infoCardConnectionConnectorLinkFieldKey: "Connector",
        infoCardConnectionConnectorProviderNameFieldKey: "Connector Provider Name",
        infoCardConnectionConnectorProviderCategoryFieldKey: "Connector Provider Category",

        infoCardApplicationTypeFieldKey: "Application Type",
        infoCardApplicationVersionFieldKey: "Version",
        infoCardApplicationQuarantineStatusFieldKey: "Quarantine Status",

        infoCardEnvironmentTypeFieldKey: "Environment Type",

        infoCardDataStorageTypeFieldKey: "Data Storage Type",
        infoCardDataStorageEntityNameFieldKey: "Entity Name",

        infoCardBotTypeFieldKey: "Agent Type",
        infoCardBotAutonomousTriggersCountFieldKey: "Autonomous Triggers Count",

        filterBy: "Filter by:",

        additionalInfoCardTitle: "Additional Info",

        environmentCardTitle: "Environment",
        environmentCardNameFieldKey: "Name",
        environmentCardPlatformFieldKey: "Platform",
        environmentCardTypeFieldKey: "Type",
        environmentPlatformLink: "Explore in Platform",
        viewRuntimeActivity: "View runtime activity",

        generativeAiCardTitle: "Gen-AI",
        generativeAiCardCreatedUsingGenerativeAiFieldKey: "Created with Gen-AI",

        timelineCardTitle: "Timeline",
        timelineCardCreatedEvent: "Created",
        timelineCardLastModifiedEvent: "Last modified",
        timelineCardLastPublishedEvent: "Last published",
        timelineCardFirstSeenEvent: "First seen by Zenity",
        timelineCardLastRunEvent: "Last run",
        timelineCardSuspensionEvent: "Suspended",
        timelineCardDlpLastEvaluated: "Dlp last evaluated",
        timelineCardDatasetLastRefresh: "Last refreshed at",
        timelineCardLastRunNotFoundMessages: {
            noLastExecutionStatus: "No data found",
            noDatafoundUsingFirstSeenAsAncorHover:
                "Data not found. This could be due to the action or process never having occurred, or the relevant data was deleted from the source platform",
            noDatafoundUsingFirstSeenAsAncorMessage: "No data found",
            possiblyNeverOccuredMessage: "Possibly never occurred, or records were deleted before usage persistency began on December-2024",
        },

        resourcesRelationsCardsTitle: "Resources Relations",
        resourcesRelationsCardShowingSampleDisclaimer: "Presenting sample of relations per resource category",
        relatedResourceCardStatusTitle: "Status:",
        relatedResourceCardResourceCategoryFieldKey: "Resource Category",
        relatedResourceCardResourceTypeFieldKey: "Resource Type",
        relatedResourceCardResourceRelationTypeFieldKey: "Relation Type",
        relatedResourceCardCreatedAtTitle: "Created At",
        relatedResourceCardResourceCreatedByIdentityNameTitle: "Created By",

        relatedViolationCardStatusTitle: "Status:",
        relatedViolationCardExploreResourceLink: "Explore ",
        brokenRelationDisclaimer: "The related resource was not found.",
        contactSupport: "Contact Support.",
        brokenRelationCardTitle: "Unknown Resource",
        relatedViolationCardExploreViolationLink: "Explore ",

        resourceViolationsCardsTitle: "Violations",
        resourceHygieneCardsTitle: "Hygiene",
        resourceViolationCardPolicyCategoryFieldKey: "Policy Category",
        resourceViolationCardFirstSeenFieldKey: "First seen",
        portalLinkDisabledTooltip: "Portal app link is deprecated",
    },
    inventoryPage: {
        tableColumns: {
            resourceName: "Resource Name",
            resourceCategory: "Category",
            resourceType: "Type",
            environment: "Environment",
            createdBy: "Created By",
            ownedBy: "Owned By",
            platform: "Platform",
            severity: "Severity",
            creationTime: "Creation Time",
            businessCriticality: "Business Criticality",
            securityRisk: "Security Risk",
            resourceStatus: "Resource Status",
        },
        filters: { search: "Search by Resource Name or Environment name" },
    },
    evidenceListPage: {
        sensitiveContentEvidence: `Select "Fetch Content" to view details.`,
    },
    aiAgentStepActivityPage: {
        tableColumns: {
            actorName: "Actor Name",
            timestamp: "Timestamp",
            stepType: "Type",
            threadId: "Thread Id",
            agentName: "Agent",
            clientApplication: "Client Application",
        },
        filters: { search: "Search by Actor Name" },
    },
    aiFindingsPage: {
        tableColumns: {
            actorName: "Actor Name",
            timestamp: "Timestamp",
            displayName: "Finding",
            severity: "Severity",
            threadId: "Thread Id",
            owasp: "OWASP LLM",
            mitreAttack: "GenAI Matrix",
        },
        filters: {
            search: "Search by finding or rule id",
            searchThreadId: "Search by thread id",
        },
    },
    aiInLineControlPage: {
        tableColumns: {
            ruleName: "Rule",
            ruleId: "Rule ID",
            preventionType: "Prevention type",
            timestamp: "Timestamp",
            agent: "Agent",
            actor: "Actor",
            threadId: "Thread ID",
        },
        subtitle: `Monitor real-time enforcement actions taken directly within AI workflows. <br>Backed by AI Edge and AIDR, this includes proactive blocking, behavior-based detection, and policy-driven control of agent activity as it happens.`,
    },
    aiDataInsightsPage: {
        tableColumns: {
            name: "Name",
            fileUrl: "URL",
            firstDetected: "First Detected",
            lastDetected: "Last Detected",
            evidence: "Evidence",
            findingsCount: "Finding Count",
        },
        subtitle:
            "Gain visibility into how AI interacts with your data: what it accesses, uses, or generates. monitor potential data exposure and take action to reduce risk.",
        sensitiveFiles: "Sensitive Files",
        sensitiveFilesDescription:
            "Files flagged by Zenity threat intelligence as sensitive and requiring review to determine whether AI should have access to them.",
    },
    aiPreventionMockPage: {
        tableColumns: {
            name: "Name",
            type: "Type",
            size: "Size",
            createdSentDate: "Created/Sent At",
            ownerCreatedSentBy: "Created/Sent By",
            status: "Status",
            agent: "Agent",
        },
    },
    aiPreventionDetailsPage: {
        idTitle: "ID:",
    },
    aiAgentStepPage: {
        idTitle: "ID:",
        overviewTabTitle: "Overview",
        citedSourcesCardTitle: "Citations",
        sourcesCardTitle: "Sources",
        timestampFieldName: "Timestamp",
        toolsCardTooltip:
            "Actions or tools, such as data analysis, email drafting, or meeting summarization, that were enabled or disabled during this step of the interaction.",
        actorsCardTitle: "Actors",
        ClientCardTitle: "Client",
        exploreThreadFindingsLinkName: "Explore Thread Findings",
        stepDetailsCardTitle: "Step Details",
        threadCardTitle: "Thread",
        timestampTitle: "Timestamp",
        toolPlatformIdFieldName: "Platform ID",
        applicationFieldName: "Application",
        agentDetailsFieldName: "Agent",
        emailFieldName: "Email",
        findingsFieldName: "Findings",
        ipAddressFieldName: "IP Address",
        messageFieldName: "Message",
        transcriptFetchingAllowedFieldName: "Member of security group (at step timestamp)",
        attachments: "Attachments",
        attachmentDeletedSuccessfully: "Attachment deleted successfully",
        attachmentDeletionFailed: "Deletion failed",
        attachmentDownloadedSuccessfully: "Attachment downloaded successfully",
        attachmentDownloadFailed: "Download failed",
        transcriptFetchingAllowedFieldDescription:
            "Zenity analyzes risks for messages that were accessible in real time. If the user was not a member of the security group at the time of the event, the message have not been analyzed.",
        nameFieldName: "Name",
        regionFieldName: "Region",
        sensitivityLabelFieldName: "Sensitivity Label",
        showPromptContentLinkName: "Fetch Message Content",
        threadIdFieldName: "Thread Id",
        urlFieldName: "URL",
        resourceTypeFieldName: "Resource Type",
        sourceIdFieldName: "Source Id",
        noFindingsFound: "No findings found",
        payload: "Payload",
        fetchPayload: "Fetch Payload Content",
        fetchToolInvocationResult: "Fetch Result Content",
        fetchToolInvocationParams: "Fetch Parameters Content",
        triggeringEvent: "Triggering Event",
        invocationParameters: "Invocation Parameters",
        toolInvocationResult: "Invocation Result",
        toolField: "Tool",
        fetchSourceSnippet: "Fetch Source Snippet",
        ragQuery: "RAG Query",
        fetchCitationSnippet: "Fetch Citation Snippet",
        snippet: "Snippet",
        environmentNameFieldName: "Environment Name",
        m365CopilotExtensionAgent: "M365 Copilot Extension Agent",
        m365CopilotExtensionAgentTooltip:
            "A custom AI agent created to extend Microsoft 365 Copilot's capabilities. It handles specific tasks declaratively while operating within the M365 environment.",
    },
    aiAgentStepTranscriptDialog: {
        title: "Agent Step Transcript",
        description: "This is the transcript of the agent step fetched from the platform.",
        confirmationDialogTitle: "Agent Step Transcript Confirmation",
        confirmationDialogDescription:
            "The transcript may contain sensitive data. <br>Are you sure you want to continue? <br>Zenity does not store this data in any way, the transcript is retrieved in real-time for display purposes only.",
        confirmationDialogNo: "No",
        confirmationDialogYes: "Yes",
        showRawData: "Show Raw Data",
        sensitiveIconToolTip: "Beginning of evidence",
    },
    aiAgentStepPayloadDialog: {
        title: "Agent Step Payload",
        description: "This is the payload of the agent step fetched from the platform.",
        confirmationDialogTitle: "Agent Step Payload Confirmation",
        confirmationDialogDescription:
            "The payload may contain sensitive data. <br>Are you sure you want to continue? <br>Zenity does not store this data in any way, the payload is retrieved in real-time for display purposes only.",
        confirmationDialogNo: "No",
        confirmationDialogYes: "Yes",
        showRawData: "Show Raw Data",
        sensitiveIconToolTip: "Beginning of evidence",
    },
    aiAgentStepToolInvocationResultDialog: {
        title: "Agent Step Tool Invocation Result",
        description: "This is the tool invocation result of the agent step fetched from the platform.",
        confirmationDialogTitle: "Agent Step Tool Invocation Result Confirmation",
        confirmationDialogDescription:
            "The tool invocation result may contain sensitive data. <br>Are you sure you want to continue? <br>Zenity does not store this data in any way, the tool invocation result is retrieved in real-time for display purposes only.",
        confirmationDialogNo: "No",
        confirmationDialogYes: "Yes",
        showRawData: "Show Raw Data",
        sensitiveIconToolTip: "Beginning of evidence",
    },
    aiAgentStepToolInvocationParamsDialog: {
        title: "Agent Step Tool Invocation Parameters",
        description: "This is the tool invocation parameters of the agent step fetched from the platform.",
        confirmationDialogTitle: "Agent Step Tool Invocation Parameters Confirmation",
        confirmationDialogDescription:
            "The tool invocation parameters may contain sensitive data. <br>Are you sure you want to continue? <br>Zenity does not store this data in any way, the tool invocation parameters is retrieved in real-time for display purposes only.",
        confirmationDialogNo: "No",
        confirmationDialogYes: "Yes",
        showRawData: "Show Raw Data",
        sensitiveIconToolTip: "Beginning of evidence",
    },
    aiAgentStepToolSourceSnippetsDialog: {
        title: "Agent Step Source Snippets",
        description: "This is the source snippets of the agent step fetched from the platform.",
        confirmationDialogTitle: "Agent Step Tool Source Snippets Confirmation",
        confirmationDialogDescription:
            "The snippets may contain sensitive data. <br>Are you sure you want to continue? <br>Zenity does not store this data in any way, the snippets is retrieved in real-time for display purposes only.",
        confirmationDialogNo: "No",
        confirmationDialogYes: "Yes",
        showRawData: "Show Raw Data",
        sensitiveIconToolTip: "Beginning of evidence",
    },
    aiFindingPage: {
        exploreActorActivityLinkName: "Explore Actor Activity",
        exploreThreadActivityLinkName: "Explore Thread Activity",
        fixSuggestionCardTitle: "Response Recommendation",
        idTitle: "Id:",
        relevantAgentStepsCardTitle: "Relevant Agent Steps",
        riskReasonCardTitle: "Why is this a risk?",
        summaryCardTitle: "Summary",
        timestampFieldName: "Timestamp",
        investigateSuggestionCardTitle: "How to investigate?",
        ruleIdLabel: "Detection Rule Id",
        threadIdLabel: "Thread Id",
        aiServiceLabel: "AI Service",
        clientApplicationLabel: "Client Application",
        agentNameLabel: "Agent",
        stepTypeLabel: "Step Type",
        stepDetailsLabel: "Step Details",
        linkToStepDetails: "View step details",
        regionLabel: "Region",
        nameLabel: "Name",
        emailLabel: "Email",
    },
    commonEntitiesInfo: {
        resourceName: "User-generated resource name as presented on the platform",
        resourceCategory: "Resource type classification as part of Zenity cross-platform model",
        resourceType: "The specific terminology used by the platform",
        platformResourceId: "Resource id as presented on the platform",
        environment: "A logical container to store and use different resources in the platform",
        createdBy: "A link to the user which created the resource",
        ownedBy: "A link to the user which owns the resource",
        orgWideAccess: "Indicates whether the resource is accessible to the entire organization",
        publicAccess: "Indicates whether the resource is accessible to the public internet",
        publicationStatus: "The bot publication status indicates whether the bot is published or not",
        version: "The version of the resource",
        userAccessAmount: "Estimation for how many users have a direct or indirect access to the resource",
        businessCriticality:
            "Evaluates the potential business importance of an automation or application, using data Zenity collects about a resource",
        securityRisk: "Evaluates the various security violations impacting a single resource",
        resourceSpecificAttributes: {
            identity: {
                identityType: "The identity type as it appears on the platform",
                identityProviderId: "The id of the identity assigned by the identity provider",
                email: "The identity email which can be used to make contact",
                department: "The department in which the user works",
                isActive: "Checks if the User can perform actions on the organization resources protected by Zenity",
                isExternal: "Checks if the user is a part of the organization Zenity protects",
                isBuilder: "Checks if the user is a builder in the platform",
            },
            connector: {
                providerName: "The Company that built the connector",
                providerCategory: "Relations between the source platform and the company that built the connector",
                version: "The version of the connector",
                backendServiceUrl: "The URL of the backend service behind the connector, relevant for custom connectors",
                isDeprecated:
                    "Indicates whether the connector is deprecated or not. Deprecated components don't get security updates and could lead to malicious activity",
            },
            connection: {
                inUse: "Indicates whether the connection is used by other resources of categories such as automations and applications",
                connectionStatus: "Whether the connection is active and usable",
                connectionAccount: "The email address or account used for connection authentication",
                connectionHostName: "The host name / domain / URI of the server / endpoint the connection connects to",
                authenticationMethod: "The authentication type the connection connects with",
                connectorLink: "The connector used to facilitate the connection",
                isOnPremises:
                    "Indicates whether the connection is to an on-premises data source like agents/gateways that are not hosted in the source platform or its cloud",
            },
            automation: {
                stepsCount: "The number of steps in the automation",
                automationType: "The automation type as it appears on the platform",
                automationStatus: "Whether the automation is active",
                automationLastRunStatus: "The status of the last run of the automation",
                usesAiModel: "Whether the automation uses an AI Model",
                isSolutionAware: "Whether the automation is inside a solution",
                isBotTrigger: "Whether automation triggers a bot",
            },
            application: {
                applicationType: "The application type as it appears on the platform",
                version: "The application version",
                quarantineStatus: "The application quarantine status as it appears on the platform",
            },
            environment: {
                environmentType: "The environment type as it appears on the platform",
            },
            dataStorage: {
                dataStorageType: "The data storage type as it appears on the platform",
                entityName: "The name of the data storage entity",
            },
            bot: {
                botType: "The bot type as it appears on the platform",
                version: "The bot version",
                autonomousTriggersCount: "The number of autonomous triggers the bot has",
            },
        },
    },
    playbooks: {
        firstTime: "There are no playbooks yet",
        description: "Description",
        emptyResults: "No results found",
        playbookWarningMessage: "Failed runs detected, please view the 'Execution History' for details",
        triggers: "Triggers",
        trigger: "Trigger",
        actions: "Actions",
        action: "Action",
        created: "Created",
        lastExecution: "Last Execution",
        status: "Status",
        statusChangeTitle: "Playbook status change",
        disableStatusMessage: "Are you sure you want to disable the following playbook?",
        enableStatusMessage: "Are you sure you want to enable the following playbook?",
        deleteTitle: "Playbook Deletion",
        deleteMessage: "Are you sure you want to delete the following playbook?",
        noExecutions: "No Executions",
        yourPlaybooks: "My Playbooks",
        executionHistory: "Execution History",
        searchBoxText: "Search by resource ID or violation ID",
        marketplace: "Marketplace",
        executionStatus: "Execution Status",
        playbookName: "Playbook Name",
        maxPlaybooksMsg: "Your tenant has reached the maximum playbooks quota",
        notAllowedToAddPlaybookMsg: "You do not have sufficient permissions to add a playbook",
        executions: "Executions",
        executionsNotFound: "No executions were found",
        copyExecutionLog: "Copy Log",
        updatePlaybookText: "Update Playbook",
        createPlaybookText: "Create New Playbook",
        multipleResourceTypeWarningText:
            "The selected options operates on different resource types. This will limit this playbook's supported actions.",
        duplicateAction: "Clone",
        secureFlowStepsTooltip: "Action is supported for flows within a solution only and is only compatible with rules: ",
        removeAccessTooltip: "Action is only compatible with guest access violations",
        waitActionTooltip: "Subsequent actions won't run if violation is resolved or exempted during wait period.",
        sendWebhookActionDisplayName: "Export to webhook",
        setCopilotAuthenticationActionDisplayName: "Set Agent Authentication",
        addOwnerToCopilotActionDisplayName: "Add Owner to Agent",
        removeAccessFromCopilotActionDisplayName: "Remove Access From Agent",
        isolateFlowResourceActionDisplayName: "Isolate Flow",
        isolateCopilotResourceActionDisplayName: "Isolate Agent",
        adminActionTooltip: "This action is allowed for Admin only.",
        apiAction: "This action is available with api-key or api-token authentication method",
        triggersConfigurationLabels: {
            ruleUpdates: {
                title: "Violation Rule Updates",
                description: "Include violations triggered by Zenity's internal rule updates",
                tooltip:
                    "This setting helps prevent false spikes in violations when Zenity updates a detection rule. By choosing ‘Exclude’, you ensure that any new violations caused by internal rule changes (which are pre-existing issues which now generate new violations) won’t trigger the playbook. Select ‘Include’ only if you want playbooks to run in response to such updates.",
            },
            violationRule: "Violation Rule",
            ruleTag: "Rule Tag",
            resourceType: "Resource Type",
            resourceTypes: "Resource Type",
            severity: "Severity",
            connectors: "Connectors",
            resourceStatus: "Resource Status",
            resourceSecurityRisk: "Resource Security Risk",
            securityRisk: "Security Risk",
            resourceBusinessCriticality: "Resource Business Criticality",
            businessCriticality: "Business Criticality",
            resourceCreatedBy: "Resource Created By",
            createdBy: "Created By",
            resourceLastModifiedBy: "Resource Last Modified By",
            lastModifiedBy: "Last Modified By",
            resourceCreatedAt: "Resource Created Time",
            createdAt: "Created Time",
            resourceCreatedSince: "Resource Created Since",
            createdSince: "Created Since",
            resourceCreatedUntil: "Resource Created Until",
            createdUntil: "Created Until",
            resourceFirstSeenAt: "Resource First Seen Time",
            firstSeenAt: "First Seen Time",
            resourceFirstSeenSince: "Resource First Seen Since",
            firstSeenSince: "First Seen Since",
            resourceFirstSeenUntil: "Resource First Seen Until",
            firstSeenUntil: "First Seen Until",
            resourceGenerativeAiOptions: "Gen-AI",
            generativeAiOptions: "Gen-AI",
            labels: "Violation Label",
            supportedResourceTypes: "Supported resource types",
            deletedLabelsWaring:
                "The playbook is configured with labels that are already deleted. Please save the playbook again to avoid this warning in the future.",
        },
    },
    playbooksMarketplace: {
        title: "Recommended playbooks",
        selectTemplateActionDisplayName: "Use this Playbook",
        noTemplatesAvailableMessage: "No available playbooks for current active integrations",
        playbookTemplates: {
            insecureCommunicationTitle: "Insecure Communication",
            insecureCommunicationSubTitle: "Handles 'Connections' without proper encryption, such as FTP vs SFTP or HTTP vs HTTPs.",
            insecureCommunicationDescription:
                "Handles 'Connections' without proper encryption, such as FTP vs SFTP or HTTP vs HTTPs. The playbook will delete the connection and send an email to the user who created it (it is also possible to send the email to other destinations).",

            personalDataAccessTitle: "Personal Data Access",
            personalDataAccessSubTitle:
                "Handles 'Connections' that were configured using a personal domain such as a personal Gmail, Yahoo or other accounts excluded from the 'Trusted Domains'.",
            personalDataAccessDescription:
                "Handles 'Connections' that were configured using a personal domain such as a personal Gmail, Yahoo or other accounts excluded from the 'Trusted Domains'. The playbook will delete the connection and send an email to the user who created it (it is also possible to send the email to other destinations).",

            implicitSharingTitle: "Implicit Sharing",
            implicitSharingSubTitle:
                "Handles cases where a user has shared a Flow with another user and unknowingly shared the underlying connection credentials.",
            implicitSharingDescription:
                "Handles cases where a user has shared a Flow with another user and unknowingly shared the underlying connection credentials, now these credentials can be used for other purposes. The playbook will delete the connection and send an email to the user who created it (it is also possible to send the email to other destinations).",

            suspiciousDataFlowTitle: "Suspicious Cloud Data Flow",
            powerplatformSuspiciousDataFlowSubTitle:
                "Handles 'Flows' that are combining data sources in a way that may cause risk, for example, a Flow that moves data from an insecure FTP Server to his organization cloud or vise-versa.",
            workatoSuspiciousDataFlowSubTitle:
                "Handles 'Recipes' that are combining data sources in a way that may cause risk, for example, a Flow that moves data from an insecure FTP Server to his organization cloud or vise-versa.",
            powerplatformSuspiciousDataFlowDescription:
                "Handles 'Flows' that are combining data sources in a way that may cause risk, for example, a Flow that moves data from an insecure FTP Server to his organization cloud or vise-versa. The playbook will stop the flow and send an email to the user who created it (it is also possible to send the email to other destinations).",
            anonymousAgentTriggerAccessTitle: "Anonymous Agent Trigger Access",
            anonymousAgentTriggerAccessSubTitle:
                "Handles 'Flows' triggering a Copilot Studio 'Agent' via an HTTP or open email trigger, potentially exposing both the Flow and the Agent to manipulation by anonymous users.",
            anonymousAgentTriggerAccessDescription:
                "Handles 'Flows' triggering a Copilot Studio 'Agent' via an HTTP or open email trigger, potentially exposing both the Flow and the Agent to manipulation by anonymous users. The playbook will stop the flow and send an email to the user who created it (it is also possible to send the email to other destinations).",
            workatoSuspiciousDataFlowDescription:
                "Handles 'Recipes' that are combining data sources in a way that may cause risk, for example, a Flow that moves data from an insecure FTP Server to his organization cloud or vise-versa. The playbook will stop the Recipe and send and send an email to a destination of the user's choosing.",
            externalUsersAccessTitle: "External Users Access",
            externalUsersAccessSubTitle: "Handles 'Connections' that are accessible to users who are not a part of your organization.",
            externalUsersAccessDescription:
                "Handles 'Connections' that are accessible to users who are not a part of your organization. The playbook will delete the connection and send an email to the user who created it (it is also possible to send the email to other destinations).",
            customConnectorMissingAuthenticationTitle: "Custom Connector Missing Authentication",
            customConnectorMissingAuthenticationSubTitle:
                "Handles 'Custom Connectors' that don't use any built-in authentication which means it's potentially passing the secrets in the headers which expose them.",
            customConnectorMissingAuthenticationDescription:
                "Handles 'Custom Connectors' that don't use any built-in authentication which means it's potentially passing the secrets in the headers which expose them. The playbook will send an email to the user who created it (it is also possible to send the email to other destinations).",
        },
    },
    playbookExecutions: {
        triggeredEntity: "Triggered Entity",
        failedAction: "Failed Action",
        logs: "Execution Logs",
        resourceName: "Resource Name",
        resourceType: "Resource Type",
        environment: "Environment",
    },
    keyboardShortcuts: {
        violations: tableSidePanelShortcuts("violation"),
        resources: tableSidePanelShortcuts("resource"),
        agentSteps: tableSidePanelShortcuts("step"),
        findings: tableSidePanelShortcuts("finding"),
        issues: tableSidePanelShortcuts("issue"),
    },
    zenityCommon: {
        platform: "Platform",
        integration: "Integration",
        policies: "Policies",
        policy: "Policy",
        playbook: "Playbook",
        playbooks: "Playbooks",
        resourceType: "Resource Type",
        resourceTypeDisplayNames: {
            copilot: "Agent",
            copilotAction: "Agent Action",
            copilotKnowledge: "Agent Knowledge",
            copilotTopic: "Agent Topic",
        },
    },
    emailTemplatePlaceholders: {
        violationName: {
            label: "%VIOLATION_NAME%",
            description: "Violation name",
        },
        violationId: {
            label: "%VIOLATION_ID%",
            description: "Violation ID",
        },
        violationSummary: {
            label: "%VIOLATION_SUMMARY%",
            description: "Explanation of what happened",
        },
        violationSeverity: {
            label: "%VIOLATION_SEVERITY%",
            description: "Violation severity",
        },
        risk: {
            label: "%RISK%",
            description: "Explanation of the potential risk",
        },
        triage: {
            label: "%TRIAGE%",
            description: "Explanation on how to triage",
        },
        violationFix: {
            label: "%HOW_TO_FIX%",
            description: "Explanation of how to mitigate the violation",
        },
        violationFirstSeen: {
            label: "%VIOLATION_FIRST_SEEN%",
            description: "Time violation was first seen by Zenity",
        },
        resourceType: {
            label: "%RESOURCE_TYPE%",
            description: "Resource type",
        },
        linkToPlatform: {
            label: "%LINK_TO_PLATFORM%",
            description: "Link to original platform resource",
        },
        linkToZenity: {
            label: "%LINK_TO_ZENITY%",
            description: "Link to Zenity",
        },
        resourceName: {
            label: "%RESOURCE_NAME%",
            description: "Resource name",
        },
        resourceId: {
            label: "%RESOURCE_ID%",
            description: "Resource id in Zenity inventory",
        },
        resourceCategory: {
            label: "%RESOURCE_CATEGORY%",
            description: "Resource category",
        },
        environmentName: {
            label: "%ENVIRONMENT_NAME%",
            description: "Environment name",
        },
        environmentType: {
            label: "%ENVIRONMENT_TYPE%",
            description: "Environment type",
        },
        inventoryResourceLink: {
            label: "%INVENTORY_RESOURCE_LINK%",
            description: "Link to Zenity inventory resource",
        },
        resourceFirstSeen: {
            label: "%RESOURCE_FIRST_SEEN_AT%",
            description: "Time resource was first seen by Zenity",
        },
        resourceCreatedAt: {
            label: "%CREATED_AT%",
            description: "Resource creation time",
        },
        resourcesCreatedBy: {
            label: "%CREATED_BY%",
            description: "Resource creator",
        },
    },
    authErrors: {
        // heading text
        headingGeneric: "Something went wrong.",
        // Secret Expired case
        headingSecretExpired: "The login attempt has failed.",
        descriptionSecretExpiredFirstLine: "SSO integrations usually use secrets that expire after a few months. Please check that your",
        descriptionSecretExpiredSecondLine: "secret has not expired. If it has expired, create a new one and contact Zenity to update it.",
        // Invitation Expired case
        headingInvitationExpired: "The invitation link has expired.",
        descriptionInvitationExpiredFirstLine:
            "It's likely that the invitation link you've received has expired. Invitation links are valid only for 1 week",
        descriptionInvitationExpiredSecondLine:
            "after creation. Please contact your company's Zenity administrator to receive a new invite link to your inbox.",
        // User Is Not In Organization case
        headingNotInOrganization: "Access Required.",
        descriptionNotInOrganizationFirstLine: "The user lacks the appropriate permissions to access the app. Please contact your company's",
        descriptionNotInOrganizationSecondLine: "Zenity administrator to be granted access and receive a new invite link to your inbox.",
        // footer text
        footerSupport: "For any additional support, please reach out to us at ",
        zenitySupportEmail: "support@zenity.io",
    },
    sensitiveDataInput: {
        description: "This may contain sensitive user content, which is fetched in real-time and not stored.",
        btnText: "Fetch Content",
    },
    inLineControlRulesPage: {
        title: "In-Line Control Rules",
    },
};

export class Label {
    public static get = (label: string) => _.get(Labels, label);

    public static getRawResourceTextFromLabel(resourceType: ResourceType): IGetSpecificRawDataLabels {
        const resourceTypeString = Label._camelCaseToCapitalized(resourceType);
        return {
            title: _.get(Labels, "commonActions.getRawResourceAction.getRawResourceSpecificResourceTypeText.title").replace(
                /\{0\}/g,
                resourceTypeString,
            ),
            rawJsonDescription: _.get(Labels, "commonActions.getRawResourceAction.getRawResourceSpecificResourceTypeText.rawJsonDescription").replace(
                /\{0\}/g,
                resourceTypeString,
            ),
        } as IGetSpecificRawDataLabels;
    }

    private static _camelCaseToCapitalized(camelCaseString: string): string {
        return camelCaseString.replace(/[A-Z]/g, (match) => ` ${match}`).replace(camelCaseString.charAt(0), camelCaseString.charAt(0).toUpperCase());
    }
}
